<template>
  <v-dialog v-model="openModal" persistent>
    <v-card>
      <v-card-text>
        <iframe :src="path" style="width: 100%; height: 70vh" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn dark class="red" @click="closeModal">
          <v-icon left>mdi-close</v-icon>
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["modal", "path"],
  watch: {
    modal(value) {
      this.openModal = value;
    },
  },
  data() {
    return {
      openModal: false,
    };
  },
  methods: {
    closeModal() {
      this.openModal = false;
      this.$emit("close-modal");
    },
  },
};
</script>